"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var get_class_1 = require("../get-class");
var has_class_1 = require("../has-class");
function addClass(element, className) {
    if (element && !has_class_1.default(element, className)) {
        element.setAttribute('class', get_class_1.default(element).trim() + ' ' + className);
    }
}
exports.default = addClass;
